/**
 * Custom Reviews — Collection Page Star Injection
 * Finds all [data-cr-product-id] containers, fetches batch stats, renders stars.
 * Re-runs automatically when new product cards are added (infinite scroll, AJAX pagination).
 * Banner aggregate loads independently via /reviews/collection-stats/:handle.
 */
(function() {
  var API_BASE = 'https://review-worker.ryan-29b.workers.dev';
  var uid = 0;
  var pending = false;
  var MIN_AGGREGATE = 3;
  var fetchedPids = {};
  var statsCache = {};
  // Sticky decision on whether the Review Rating filter must stay hidden. The coverage ratio
  // is collection-wide and doesn't change when a shopper narrows to a subset, so we compute it
  // once and re-assert it after every AJAX facet re-render (see on:facet-filters:updated below).
  var hideRatingFilter = false;

  function injectStars() {
    var containers = document.querySelectorAll('[data-cr-product-id]');
    if (containers.length === 0) return;

    var productIds = [];
    var containerMap = {};

    for (var c = 0; c < containers.length; c++) {
      if (containers[c].innerHTML.trim() !== '') continue;
      var pid = containers[c].dataset.crProductId;
      if (!pid) continue;
      if (fetchedPids[pid]) {
        if (statsCache[pid]) {
          containers[c].innerHTML = buildStars(statsCache[pid].average, statsCache[pid].count);
        }
        continue;
      }
      if (!containerMap[pid]) {
        containerMap[pid] = [];
        productIds.push(pid);
      }
      containerMap[pid].push(containers[c]);
    }

    if (productIds.length === 0) return;

    for (var p = 0; p < productIds.length; p++) {
      fetchedPids[productIds[p]] = true;
    }

    fetch(API_BASE + '/reviews/batch-stats', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ productIds: productIds }),
    })
    .then(function(res) { return res.json(); })
    .then(function(stats) {
      for (var pid in stats) {
        var data = stats[pid];
        if (!data || !data.count) continue;
        statsCache[pid] = { average: data.average, count: data.count };
        var els = containerMap[pid];
        if (!els) continue;

        for (var e = 0; e < els.length; e++) {
          if (els[e].innerHTML.trim() !== '') continue;
          els[e].innerHTML = buildStars(data.average, data.count);
        }
      }
    })
    .catch(function() {});
  }

  function buildStars(avg, count) {
    var svg = '';
    for (var i = 1; i <= 5; i++) {
      var pct = Math.min(100, Math.max(0, (avg - i + 1) * 100));
      var gid = 'cr-c-' + (uid++);
      svg += '<svg width="14" height="14" viewBox="0 0 24 24" style="flex-shrink:0">' +
        '<defs><linearGradient id="' + gid + '" x1="0%" x2="100%">' +
        '<stop offset="' + pct + '%" stop-color="#F5A623"/>' +
        '<stop offset="' + pct + '%" stop-color="transparent"/>' +
        '</linearGradient></defs>' +
        '<path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" ' +
        'fill="url(#' + gid + ')" stroke="#F5A623" stroke-width="1.5" stroke-linejoin="round"/></svg>';
    }
    return '<div style="display:inline-flex;align-items:center;gap:4px;margin-top:4px;">' +
      '<div style="display:inline-flex;gap:1px;">' + svg + '</div>' +
      '<span style="font-size:13px;color:#6b6b6b;">(' + count + ')</span></div>';
  }

  function loadAggregate() {
    var el = document.getElementById('cr-collection-aggregate');
    if (!el) return;
    var handle = el.dataset.collectionHandle;
    if (!handle) return;

    if (el.dataset.crServerRendered === 'true') {
      var reviewed = parseInt(el.dataset.crReviewed, 10);
      var total = parseInt(el.dataset.crTotal, 10);
      if (reviewed && total) {
        toggleRatingFilter({ reviewedProducts: reviewed, totalProducts: total });
      }
      return;
    }

    fetch(API_BASE + '/reviews/collection-stats/' + encodeURIComponent(handle))
    .then(function(res) { return res.json(); })
    .then(function(data) {
      if (!data) return;
      toggleRatingFilter(data);
      if (data.count < MIN_AGGREGATE) return;
      renderAggregate(el, data.average, data.count);
    })
    .catch(function() {});
  }

  function toggleRatingFilter(data) {
    if (!data.totalProducts || !data.reviewedProducts) return;
    var ratio = data.reviewedProducts / data.totalProducts;
    hideRatingFilter = ratio < 0.5;
    applyRatingFilterVisibility();
  }

  // Hide the Review Rating filter if the sticky decision says so. Safe to call any number of
  // times, and specifically re-run after AJAX filtering re-renders the facet form (which
  // otherwise resurrects the filter, since the hide was only an inline style on the old node).
  function applyRatingFilterVisibility() {
    if (!hideRatingFilter) return;
    var filter = document.getElementById('filter-filter.p.m.custom.review_rating');
    if (filter) filter.parentElement.style.display = 'none';
  }

  function renderAggregate(el, avg, totalCount) {
    var starColor = '#F5A623';
    var textColor = 'rgba(0,15,28,0.6)';
    var heading = el.previousElementSibling;
    if (heading) {
      var rgb = window.getComputedStyle(heading).color;
      var m = rgb.match(/(\d+),\s*(\d+),\s*(\d+)/);
      if (m) {
        var brightness = (parseInt(m[1]) * 299 + parseInt(m[2]) * 587 + parseInt(m[3]) * 114) / 1000;
        if (brightness > 180) {
          starColor = '#FFD54F';
          textColor = 'rgba(255,255,255,0.75)';
        }
      }
    }

    var svg = '';
    for (var i = 1; i <= 5; i++) {
      var pct = Math.min(100, Math.max(0, (avg - i + 1) * 100));
      var gid = 'cr-c-' + (uid++);
      svg += '<svg width="18" height="18" viewBox="0 0 24 24" style="flex-shrink:0">' +
        '<defs><linearGradient id="' + gid + '" x1="0%" x2="100%">' +
        '<stop offset="' + pct + '%" stop-color="' + starColor + '"/>' +
        '<stop offset="' + pct + '%" stop-color="transparent"/>' +
        '</linearGradient></defs>' +
        '<path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" ' +
        'fill="url(#' + gid + ')" stroke="' + starColor + '" stroke-width="1.5" stroke-linejoin="round"/></svg>';
    }
    var label = totalCount === 1 ? '1 review' : totalCount + ' reviews';
    el.innerHTML = '<div style="display:inline-flex;align-items:center;gap:5px;">' +
      '<div style="display:inline-flex;gap:1px;">' + svg + '</div>' +
      '<span style="font-size:14px;color:' + textColor + ';">' + avg.toFixed(1) + ' (' + label + ')</span></div>';
  }

  function scheduleInject() {
    if (pending) return;
    pending = true;
    setTimeout(function() {
      pending = false;
      injectStars();
    }, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      injectStars();
      loadAggregate();
    });
  } else {
    injectStars();
    loadAggregate();
  }

  // facet-filters.js replaces the whole #facets form on every filter/sort change and dispatches
  // this event afterwards. Re-assert the rating-filter hide so an unrelated filter click can't
  // resurrect a filter that's supposed to stay hidden for this collection.
  document.addEventListener('on:facet-filters:updated', applyRatingFilterVisibility);

  var obs = new MutationObserver(function(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var nodes = mutations[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        if (nodes[j].nodeType === 1 && (nodes[j].querySelector('[data-cr-product-id]') || nodes[j].hasAttribute('data-cr-product-id'))) {
          scheduleInject();
          return;
        }
      }
    }
  });
  obs.observe(document.body || document.documentElement, { childList: true, subtree: true });
})();
